import axios from 'axios';

// REACT_APP_API_BASEURL is the API root, e.g. https://init-together-api.test/api/v2.
// Admin, auth and public URLs are all derived from it. A value still ending in
// /admin (the old meaning of this variable) is accepted so an un-updated build env keeps working.
const API_BASE_URL = (process.env.REACT_APP_API_BASEURL || '').replace(/\/+$/, '').replace(/\/admin$/, '');

// Admin API, including auth: /auth/sign-in, /auth/sign-out, /user/current.
export const ADMIN_API_URL = API_BASE_URL + '/admin';
// Public event/app API.
export const PUBLIC_API_URL = API_BASE_URL + '/app';


export default axios.create({
    baseURL: ADMIN_API_URL
});

export const axiosAuth = axios.create({
    baseURL: ADMIN_API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});

// Read the token per request: a header fixed at module load would send the token
// from when the page was opened (often none), breaking /user/current after login.
axiosAuth.interceptors.request.use(config => {
    const token = localStorage.getItem('aT');
    if (token && !config.headers['Authorization']) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
});

export const axioPrivate = axios.create({
    baseURL: ADMIN_API_URL,
    headers: { 'Content-Type': 'application/json'},
    withCredentials: true
});

export const axioPrivateLogin = axios.create({
    baseURL: PUBLIC_API_URL,
    headers: { 'Content-Type': 'application/json'},
});